<template>
<div class="meals-tab">
    
    <h2><slot name="mainTitle"></slot></h2>
    <div class="meals-wrapper">
            <div class="meals-item button_su" v-for="(label, i) in labels" :key="label.id" @click="renderFood(label, i)">

                <span class="su_button_circle"></span>

                <div class="button_su_inner" :class="{ active: i === activeItem}">
                    <h3>{{ label.label }}</h3>
                </div>
            </div>
       
    </div>

   

         <transition name="fade">
        <MenuSection :meals="clickedFood" :isDelivery="this.isDelivery" :isBrunch="this.isBrunch"></MenuSection>
         </transition>
   
</div>
</template>

<script>

import MenuSection from '@/components/MenuSection/MenuSection.vue';
export default {
    show: false,
    props: ['labels', 'title', 'isDelivery', 'isBrunch'],
    activeItem: null,
    data: () => ({
        clickedFood: [],
        selectedTab: ''
    }),
    components: {
        MenuSection
    },
    methods: {
        renderFood(label, i) {
            this.clickedFood = this.meals.filter(meal => meal.types[0].id === label.id);
            this.selectedTab = label.label;
            this.activeItem = i;
        }
    },
    watch: {
        meals: function() {
            this.renderFood(this.$props.labels[0], 0);
        }
    },
    computed: {
        meals() {
        return this.$store.getters.allMeals
        }
	},
	mounted() {
        this.$store.dispatch("getMeals") 
        let button_su_inner = document.querySelectorAll('.button_su_inner');
        button_su_inner.forEach(element => {
                element.addEventListener('mouseenter', e => {
              let rect = element.getBoundingClientRect();
              let offset = {
                top: rect.top + window.scrollY, 
                left: rect.left + window.scrollX,
              };

              let relX = e.pageX - offset.left;
              let relY = e.pageY - offset.top;

               let circle = element.previousSibling;
              circle.style.left = relX + 'px';
              circle.style.top = relY + 'px';

              element.previousSibling.classList.remove('desplode-circle');
              element.previousSibling.classList.add('explode-circle');
            });

            element.addEventListener('mouseleave', e => {
              let rect = element.getBoundingClientRect();
              let offset = {
                top: rect.top + window.scrollY, 
                left: rect.left + window.scrollX,
              };

              let relX = e.pageX - offset.left;
              let relY = e.pageY - offset.top;

              let circle = element.previousSibling;
              circle.style.left = relX + 'px';
              circle.style.top = relY + 'px';
              element.previousSibling.classList.remove('explode-circle');
              element.previousSibling.classList.add('desplode-circle');
            });
        });
	},
};

</script>

<style scoped lang="scss">

@import '../components/variables.scss';

h2 {
    font-size: 2.2rem;
    margin: 1em 0;

}

.meals-wrapper {
    display:flex;
    justify-content: center;

        @include screen(xs) {
            flex-wrap:wrap;
        } 

}



.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.button_su{
  overflow: hidden;
  position: relative;
  display: inline-block;
  border-radius: 3px;
  margin-right:1em;

  @include screen('mobile') {
            
                margin-bottom:1em;
               
            }
}

.su_button_circle{
  background-color: red;
  border-radius: 1000px;
  position: absolute;
  left:0;
  top:0;
  width: 0px;
  height: 0px;
  margin-left: 0px;
  margin-top: 0px;
  pointer-events: none;
  /*animation-timing-function: ease-in-out; */
}

.button_su_inner{
    display: inline-block;
    background: #ffc63e;
    color: white;
    font-size: 16px;
    font-weight: normal;
    width: fit-content;
    text-align: center;
    border-radius: 3px;
    transition: 400ms;
    text-decoration: none;
    padding: 22px;
    z-index: 100000;

    @include screen('mobile') {
                padding:10px;
                font-size:14px;
            }

&.active {
  background-color:rgba(224, 36, 27, 1);
  color:white;
}

h3 {
    z-index:1000;
    position:relative;
    color:white;
}
}

.explode-circle {
   animation: explode 0.5s forwards;

}

.desplode-circle{
   animation: desplode 0.5s forwards;
}

@keyframes explode {
  0% {
    width: 0px;
    height: 0px;
    margin-left: 0px;
    margin-top: 0px;
    background-color: rgba(224, 36, 27, .2);
  }
  100% {
    width: 500px;
    height: 400px;
    margin-left: -200px;
    margin-top: -200px;
    background-color: rgba(224, 36, 27, 1);
  }
}

@keyframes desplode {
  0% {
    width: 500px;
    height: 400px;
    margin-left: -200px;
    margin-top: -200px;
    background-color: rgba(224, 36, 27, 1);
  }
  100% {
    width: 0px;
    height: 0px;
    margin-left: 0px;
    margin-top: 0px;
    background-color: rgba(224, 36, 27, .2);
  }
}

</style>